module.exports = __webpack_public_path__ + "static/gallery-15@2x-491bdbdf6dcb77bcf7aee1ee5e984fcf.jpg";